<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout v-if="validPayment != false" justify-center row mb-2>
                    <v-flex class="text-xs-center" xs12>
                        
                    </v-flex>
                </v-layout>
                <v-layout justify-center row v-if="validPayment == true && !resourcePath">
                    <div class="text-xs-center xs12 md12 lg4 xl4 offset-lg-4 offset-xl-4">
                        <form :action="formAction" class="paymentWidgets text-xs-center" data-brands="VISA MASTER AMEX APPLEPAY"></form>
                    </div>
                </v-layout>
                <v-layout v-else-if="validPayment == false" row wrap>
                    <v-flex xs12>Invalid Payment ID</v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';
import sweetAlert from '../sweetAlert.js';

export default {
    data() {
        return {
            form: {},
            paymentId: this.$route.params.id,
            paymentData: [],
            channel: {},
            validPayment: null,
            merchantName: null,
            checkoutId: null,
            resourcePath: null,
            host: window.location.hostname
        }
    },
    mixins: [ sweetAlert ],
    mounted() {
        this.getPaymentStatusPath();
    },
    computed: {
        formAction() {
            if(this.host == 'localhost') {
                return `http://localhost:8080/reg-by-link/${this.paymentId}`;
            }
            else {
                return `https://management.totalprocessing.com/reg-by-link/${this.paymentId}`;
            }
        }
    },
    methods: {
        getPayment() {
            if(!this.resourcePath) {
                axios({
                method: 'post',
                data: { paymentId: this.paymentId },
                url: 'https://controlapi.totalprocessing.com/api/get-reg-by-link',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.paymentData = response.data[0];
                    this.validPayment = this.paymentData != undefined ? true : false;

                    if(this.validPayment) {
                        this.merchantName = response.data[0].merchantName;
                        this.form.merchantTransactionId = response.data[0].merchantTransactionId;
                        this.form.email = response.data[0].email;

                        this.channel.url = 'oppwa.com';
                        this.channel.userId = response.data[0].channelLogin;
                        this.channel.password = response.data[0].channelPwd;
                        this.channel.entityId = response.data[0].channelUuid;

                        this.onSubmit();
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                this.validPayment = false;
            }
        },
        onSubmit() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/process-request',
                data: { merchantTransactionId: this.form.merchantTransactionId, channel: this.channel, paymentType: 4 },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    var jq = document.createElement('script');
                    jq.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js');
                    document.head.appendChild(jq);

                    const cnp = document.createElement('script');
                    cnp.setAttribute('src', 'https://dally.totalprocessing.com/jarvis_cnp.js');
                    document.head.appendChild(cnp);

                    const copyAndPayScript = document.createElement('script');
                    this.checkoutId = response.data.id;

                    copyAndPayScript.setAttribute('src', 'https://oppwa.com/v1/paymentWidgets.js?checkoutId='+this.checkoutId);
                    document.head.appendChild(copyAndPayScript);
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        getPaymentStatusPath() {
            this.resourcePath = decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent('resourcePath').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            this.resourcePath = this.resourcePath.length > 0 ? this.resourcePath : null;

            if(this.resourcePath) {
                this.getPaymentStatus();
            }
            else {
                this.getPayment();
            }
        },
        getPaymentStatus() {
            if(this.resourcePath.includes('/v1/checkouts/')) {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-payment-status',
                data: { resourcePath: this.resourcePath, paymentId: this.paymentId },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.sweetAlert(response.data);
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
    }
}
</script>

<style scoped>
    .wpwl-form {
        margin: 0 !important;
    }
</style>